import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Custom element that displays delivery time information based on the
 * `custom.delivery_from_store` variant metafield (boolean).
 * Updates reactively when the selected variant changes.
 *
 * @extends {Component}
 */
class DeliveryTime extends Component {
  /** @type {Element | null} */
  #target = null;

  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('.shopify-section, dialog');
    if (!this.#target) return;
    this.#target.addEventListener(ThemeEvents.variantUpdate, this.updateDelivery);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#target?.removeEventListener(ThemeEvents.variantUpdate, this.updateDelivery);
    this.#target = null;
  }

  /**
   * Updates the rendered delivery info when the active variant changes.
   * @param {VariantUpdateEvent} event
   */
  updateDelivery = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const newElement = event.detail.data.html.querySelector(
      `delivery-time[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newElement) {
      this.hidden = true;
      return;
    }

    this.hidden = newElement.hidden;
    this.dataset.productId = newElement.dataset.productId || this.dataset.productId;

    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('delivery-time')) {
  customElements.define('delivery-time', DeliveryTime);
}
